<template>
  <div>
    <b-tree-view :data="treeData" :contextMenuItems="treeData"></b-tree-view>
</div>
</template>

<script>
  import { bTreeView } from 'bootstrap-vue-treeview';
  export default {
    name: "DORowDetail",
    props: {
      details: {
        default: function () { return []; },
        type: Object
      }
    },
    components: {
    bTreeView
},
    data() {
    const tData = [];
    for (var key in this.details) {
       var o = {};
        o.Id = key;
        o.name = key + ' : ' + this.details[key];
        tData.push(o);
    }
      return {
           treeData: tData
    };
    }
  };
</script>



// WEBPACK FOOTER //
// src/components/DORowDetail.vue